// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".089167e632fcb27145fd0e57c33b45217b32bf1d.chunk.bundle.js";
};